import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { api } from '../services/apiService';
import './ServicesSection.css';
import parse from "html-react-parser";

const ServicesSection = () => {
  const { addToCart } = useCart();
  const [servicesData, setServicesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadServices = async () => {
      try {
        setLoading(true);
        const response = await api.get('/services', { is_active: 1 });
        const services = response.data || [];

        // Group by category
        const grouped = services.reduce((acc, svc) => {
          const key = svc.category;
          if (!acc[key]) acc[key] = [];
          acc[key].push({
            id: svc.id,
            name: svc.name,
            description: svc.description,
            pricePerHour: parseFloat(svc.price_per_hour),
          });
          return acc;
        }, { cleaningServices: [], cookingServices: [], careServices: [] });

        setServicesData(grouped);
      } catch (err) {
        setError('Failed to load services. Showing default services.');
        console.error('Error loading services:', err);
      } finally {
        setLoading(false);
      }
    };

    loadServices();
  }, []);

  // Fallback data structure
  const fallbackData = {
    cleaningServices: [
      { id: 1, name: "Sweeping", description: "Thorough floor sweeping service", pricePerHour: 150 },
      { id: 2, name: "Mopping", description: "Deep floor mopping and cleaning", pricePerHour: 200 },
      { id: 3, name: "Utensils", description: "Complete utensil cleaning and sanitization", pricePerHour: 180 },
      { id: 4, name: "Kitchens", description: "Comprehensive kitchen cleaning service", pricePerHour: 300 },
      { id: 5, name: "Bathrooms", description: "Deep bathroom cleaning and sanitization", pricePerHour: 250 },
      { id: 6, name: "Dusting", description: "Complete dusting of all surfaces", pricePerHour: 150 },
      { id: 7, name: "Laundry", description: "Washing, drying, and folding services", pricePerHour: 200 },
      { id: 8, name: "Balcony", description: "Balcony cleaning and maintenance", pricePerHour: 180 }
    ],
    cookingServices: [
      { id: 1, name: "Meal Preparation", description: "Daily meal planning and preparation", pricePerHour: 400 },
      { id: 2, name: "Breakfast Service", description: "Fresh breakfast preparation", pricePerHour: 300 },
      { id: 3, name: "Lunch Service", description: "Nutritious lunch preparation", pricePerHour: 350 },
      { id: 4, name: "Dinner Service", description: "Evening meal preparation", pricePerHour: 400 },
      { id: 5, name: "Snack Preparation", description: "Healthy snack options", pricePerHour: 250 },
      { id: 6, name: "Special Occasions", description: "Catering for special events", pricePerHour: 500 },
      { id: 7, name: "Dietary Planning", description: "Customized meal plans", pricePerHour: 350 },
      { id: 8, name: "Grocery Shopping", description: "Assistance with grocery shopping", pricePerHour: 200 }
    ],
    careServices: [
      { id: 1, name: "Elderly Care", description: "Compassionate care for elderly family members", pricePerHour: 500 },
      { id: 2, name: "Child Care", description: "Safe and nurturing child care services", pricePerHour: 400 },
      { id: 3, name: "Pet Care", description: "Pet feeding, walking, and care", pricePerHour: 300 },
      { id: 4, name: "Plant Care", description: "Indoor and outdoor plant maintenance", pricePerHour: 200 },
      { id: 5, name: "Home Monitoring", description: "Regular home check-ins and monitoring", pricePerHour: 250 },
      { id: 6, name: "Medication Reminders", description: "Timely medication reminders", pricePerHour: 200 },
      { id: 7, name: "Companionship", description: "Friendly companionship services", pricePerHour: 300 },
      { id: 8, name: "Emergency Assistance", description: "24/7 emergency support", pricePerHour: 600 }
    ]
  };

  const data = servicesData || fallbackData;

  if (loading) {
    return (
      <div className="services-section">
        <div className="loading-message">Loading services...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="services-section">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  const handleAddToCart = (service, category) => {
    addToCart(service, category);
  };

  const renderServiceCard = (service, category) => (
    <div key={service.id} className="service-card">
      <div className="service-card-content">
        <h4 className="service-name">{service.name}</h4>
        <p className="service-description">{parse(service.description)}</p> 
        <div className="service-price-section">
          <span className="service-price">₹{service.pricePerHour || 0}</span>
          <span className="price-label">/hr</span>
        </div>
        <button 
          className="add-to-cart-btn"
          onClick={() => handleAddToCart(service, category)}
        >
          Add to Cart
        </button>
      </div>
    </div>
  );

  const renderServiceSection = (title, services, icon, categoryKey) => (
    <div className="service-category">
      <div className="category-header">
        <span className="category-icon">{icon}</span>
        <h2 className="category-title">{title}</h2>
      </div>
      <div className="service-cards-grid">
        {services && services.length > 0 ? (
          services.map(service => renderServiceCard(service, categoryKey))
        ) : (
          <p className="no-services">No services available</p>
        )}
      </div>
    </div>
  );

  return (
    <div className="services-section">
      {renderServiceSection("Cleaning Services", data.cleaningServices, "🧹", "cleaningServices")}
      {renderServiceSection("Assistance Services", data.careServices, "💚", "careServices")}      
      {/* {renderServiceSection("Cooking Services", data.cookingServices, "👨‍🍳", "cookingServices")} */}
     
    </div>
  );
};

export default ServicesSection;

